import React, { useEffect, useState } from 'react';
import { query, collection, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../FirebaseComp/firebase'; 
import { FaGraduationCap, FaCalendarAlt, FaFileAlt, FaMoneyBillWave, 
         FaUniversity, FaQuestionCircle, FaGlobeAsia, FaChalkboardTeacher, 
         FaCheck, FaChevronDown, FaChevronUp, FaLaptop, FaRobot, 
         FaCode, FaAssistiveListeningSystems, FaPills } from 'react-icons/fa';

         import { FaCertificate } from 'react-icons/fa';


import './admission.css';
import { Link } from 'react-router-dom';

const Admission = () => {

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const [activeTab, setActiveTab] = useState('technology');
  const [showModal, setShowModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    program: '',
    personalInfo: {
      name: '',
      email: '',
      phone: '',
      country: ''
    },
    education: {
      institution: '',
      qualification: '',
      year: ''
    },
    documents: {
      transcript: null,
      recommendation: null,
      personalStatement: null
    },
    payment: {
      method: '',
      receipt: null
    },
    agreeTerms: false
  });

  // Updated admission types with APC's specific programs
  const admissionTypes = [
    {
      id: 'technology',
      title: 'Technology Programs',
      icon: <FaLaptop />,
      programs: [
        'Certificate in Information Technology',
        'Diploma in Information Technology',
        'Certificate in Artificial Intelligence',
        'Certificate in Web Design & Development'
      ],
      requirements: [
        'O/Ls with English and Mathematics',
        'Basic computer literacy',
        'Passion for technology and innovation'
      ],
      deadlines: [
        'Quarterly Intakes: January, April, July, October',
        'Early Application Deadline: 1 month before intake'
      ]
    },
    {
      id: 'health',
      title: 'Health Science Programs',
      icon: <FaPills />,
      programs: [
        'Certificate in Audiology',
        'Diploma in Audiology',
        'Certificate in Pharmacology',
        'Diploma in Pharmacology'
      ],
      requirements: [
        'A/Ls with Biology/Chemistry for Diploma programs',
        'O/Ls with Science for Certificate programs',
        'Medical certificate (for health-related programs)'
      ],
      deadlines: [
        'Bi-annual Intakes: January, July',
        'Application Deadline: 6 weeks before intake'
      ]
    },


   
    {
      id: 'professional',
      title: 'Professional Development',
      icon: <FaChalkboardTeacher />,
      programs: [
        'Industry Certifications',
        'Short Courses',
        'Corporate Training'
      ],
      requirements: [
        'Relevant work experience for some programs',
        'Minimum O/L qualifications'
      ],
      deadlines: [
        'Rolling Admissions',
        'Cohort Programs: Quarterly'
      ]
    }
  ];

  const applicationSteps = [
    {
      step: 1,
      title: 'Choose Program',
      description: 'Select from our certificate and diploma programs'
    },
    {
      step: 2,
      title: 'Check Requirements',
      description: 'Verify you meet all admission criteria'
    },
    {
      step: 3,
      title: 'Prepare Documents',
      description: 'Gather transcripts, ID copies, and other requirements'
    },
    {
      step: 4,
      title: 'Submit Application',
      description: 'Complete online application with fee'
    },
    {
      step: 5,
      title: 'Assessment',
      description: 'Technical test (for IT programs) or interview'
    },
    {
      step: 6,
      title: 'Receive Decision',
      description: 'Get admission result within 2-3 weeks'
    }
  ];

  const tuitionData = {
    technology: [
      { program: 'Certificate Programs', fee: 'LKR 150,000 - 200,000' },
      { program: 'Diploma Programs', fee: 'LKR 250,000 - 300,000/year' }
    ],
    health: [
      { program: 'Certificate Programs', fee: 'LKR 175,000 - 225,000' },
      { program: 'Diploma Programs', fee: 'LKR 275,000 - 350,000/year' }
    ]

  };

  // const faqs = [
  //   {
  //     question: "What's the difference between certificate and diploma?",
  //     answer: "Certificates are 6-month programs focusing on core skills, while diplomas are 1-year comprehensive programs with practical training and industry placements."
  //   },
  //   {
  //     question: "Can I upgrade from certificate to diploma?",
  //     answer: "Yes, certificate graduates can progress to diploma programs with credit transfer for completed modules."
  //   },
  //   {
  //     question: "Are there installment plans available?",
  //     answer: "APC offers flexible payment plans with 3-6 installments for all diploma programs."
  //   },
  //   {
  //     question: "What career support does APC provide?",
  //     answer: "We offer resume workshops, interview preparation, and direct industry connections through our career development center."
  //   },
  //   {
  //     question: "Is hostel accommodation available?",
  //     answer: "Yes, we provide safe and affordable hostel facilities near campus for both local and international students."
  //   },
  //   {
  //     question: "What are the lab facilities like?",
  //     answer: "APC has state-of-the-art labs for each program, including computer labs with latest software, audiology testing rooms, and pharmacology research labs."
  //   }
  // ];

  // Rest of your existing state and functions remain the same...

  return (
    <div className="admission-page">
      {/* Hero Section */}
      <section className="admission-hero">
        <div className="hero-content">
          <h1>Begin Your APC Journey</h1>
          <p>Join Sri Lanka's premier technical education institution with industry-aligned programs</p>
        </div>
      </section>

      {/* Admission Pathways */}
      <section className="pathways-section">
        <div className="container">
          <h2>Program Admission</h2>
          <p className="section-subtitle">Choose your field of study</p>
          
          <div className="pathways-tabs">
            {admissionTypes.map(type => (
              <button
                key={type.id}
                className={`tab-button ${activeTab === type.id ? 'active' : ''}`}
                onClick={() => setActiveTab(type.id)}
              >
                <span className="tab-icon">{type.icon}</span>
                {type.title}
              </button>
            ))}
          </div>

          <div className="pathways-content">
            {admissionTypes.filter(type => type.id === activeTab).map(type => (
              <div key={type.id} className="pathway-details">
                <div className="detail-column">
                  <h3>Available Programs</h3>
                  <ul>
                    {type.programs.map((program, index) => (
                      <li key={index}>
                        {program.includes('Certificate') ? <FaCertificate /> : <FaGraduationCap />}
                        {program}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="detail-column">
                  <h3>Admission Requirements</h3>
                  <ul>
                    {type.requirements.map((req, index) => (
                      <li key={index}><FaCheck /> {req}</li>
                    ))}
                  </ul>
                </div>

                <div className="detail-column">
                  <h3>Intake Periods</h3>
                  <ul>
                    {type.deadlines.map((deadline, index) => (
                      <li key={index}><FaCalendarAlt /> {deadline}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Application Process */}
      <section className="process-section">
        <div className="container">
          <h2>Application Process</h2>
          <p className="section-subtitle">4 simple steps to join APC</p>
          
          <div className="process-steps">
            {applicationSteps.map(step => (
              <div key={step.step} className="step-card">
                <div className="step-number">{step.step}</div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tuition Information */}
      <section className="tuition-section">
        <div className="container">
          <h2>Program Fees</h2>
          <p className="section-subtitle">Affordable education with flexible payment options</p>
          
          <div className="tuition-cards">
            {Object.entries(tuitionData).map(([category, fees]) => (
              <div key={category} className="tuition-card">
                <h3>{admissionTypes.find(t => t.id === category).title}</h3>
                <table>
                  <thead>
                    <tr>
                      <th>Program Level</th>
                      <th>Total Fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fees.map((fee, index) => (
                      <tr key={index}>
                        <td>{fee.program}</td>
                        <td>{fee.fee}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <button className="fee-details-button">View Detailed Breakdown</button>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* FAQ Section */}
      {/* <section className="faq-section">
        <div className="container">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            {faqs.map((faq, index) => (
              <div 
                className={`faq-item ${activeIndex === index ? 'active' : ''}`} 
                key={index}
                onClick={() => toggleFAQ(index)}
              >
                <div className="faq-question">
                  <h3>
                    <FaQuestionCircle /> {faq.question}
                    {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                  </h3>
                </div>
                {activeIndex === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="admission-cta">
        <div className="container">
          <h2>Ready to Apply?</h2>
          <p>Next intake begins August</p>
          <div className="cta-buttons">
            <Link to="/apply" className="primary-cta">Start Your Application</Link>

          </div>
        </div>
      </section>

      {/* Application Modal would remain the same */}
    </div>
  );
};

export default Admission;